import React, { useState } from 'react';
import Calendar from '../../components/calendar/Calendar';
import SessionCard from './components/SessionCard';
import { format } from 'date-fns';
import { Plus } from 'lucide-react';
import Button from '../../components/ui/Button';

const Schedule = () => {
  const [selectedEvent, setSelectedEvent] = useState(null);

  // Mock events - replace with API data
  const events = [
    {
      id: 1,
      title: 'Advanced Calculus',
      start: '2024-03-20T10:00:00',
      end: '2024-03-20T11:00:00',
      extendedProps: {
        teacherName: 'Dr. Sarah Johnson',
        teacherImage: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&auto=format&fit=crop&w=128&q=80',
      },
      backgroundColor: '#818CF8',
      borderColor: '#818CF8'
    },
    // Add more events
  ];

  const handleEventClick = (clickInfo) => {
    setSelectedEvent(clickInfo.event);
  };

  const handleDateSelect = (selectInfo) => {
    const title = prompt('Please enter session title');
    if (title) {
      const newEvent = {
        id: Date.now(),
        title,
        start: selectInfo.startStr,
        end: selectInfo.endStr,
        backgroundColor: '#818CF8',
        borderColor: '#818CF8'
      };
      // Add event handling logic here
    }
    selectInfo.view.calendar.unselect();
  };

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div className="flex justify-between items-center mb-8">
        <h1 className="text-3xl font-bold">Schedule</h1>
        <Button>
          <Plus className="h-5 w-5 mr-2" />
          New Session
        </Button>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
        <div className="lg:col-span-3">
          <Calendar 
            events={events}
            onEventClick={handleEventClick}
            onDateSelect={handleDateSelect}
          />
        </div>

        <div className="space-y-6">
          <div className="bg-white rounded-xl shadow-sm p-6">
            <h2 className="text-xl font-semibold mb-4">Upcoming Sessions</h2>
            {events.map(event => (
              <SessionCard
                key={event.id}
                session={{
                  subject: event.title,
                  teacherName: event.extendedProps?.teacherName,
                  teacherImage: event.extendedProps?.teacherImage,
                  time: format(new Date(event.start), 'h:mm a'),
                  duration: '60 min'
                }}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Schedule;